import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

interface LoadingContainerProps {
  fullScreen?: boolean;
}

export const LoadingContainer = styled.div<LoadingContainerProps>`
  position: ${props => props.fullScreen ? 'fixed' : 'absolute'};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.fullScreen 
    ? 'rgba(255, 255, 255, 0.8)' 
    : 'rgba(255, 255, 255, 0.5)'};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid ${({ theme }) => theme.card};
  border-top: 5px solid ${({ theme }) => theme.primaryAccent};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`; 